import { FC } from 'react';
import AssociateSelect from '../AssociateSelect';
import SearchFormItem from './subpage/searchFormItem';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import { AssociateSelectProps } from '../AssociateSelect/associateSelect';

export interface SearchFormAssociateSelectProps
  extends BaseSearchFormItemProps {
  /** 下拉匹配参数 */
  associateSelectProps?: AssociateSelectProps;
}
/** 下拉匹配 */
export const SearchFormAssociateSelect: FC<SearchFormAssociateSelectProps> = props => {
  const {
    associateSelectProps,
    isDetail,
    testId,
    name,
    label,
    rules,
    ...resProps
  } = props;
  return (
    <SearchFormItem name={name} {...resProps} label={label} rules={rules}>
      <AssociateSelect
        isDetail={isDetail}
        {...associateSelectProps}
        placeholder={getSelectPlaceholder(label, associateSelectProps, rules)}
        test-id={`${testId}-${name}`}
      />
    </SearchFormItem>
  );
};

SearchFormAssociateSelect.displayName =
  SearchFormItemEnum.SearchFormAssociateSelect;

export default SearchFormAssociateSelect;
